// Skaitinių kodų → tikrų pavadinimų lentelės, naudojamos "Žiūrėti" peržiūros
// dialoge (ItemViewDialog.jsx) rodyti prekės savybes žmogui suprantamai, o ne
// kaip neišverstus lauko raktus su skaitiniais kodais (pvz. "manufacturer: 1").
// Nukopijuota TIKSLIAI iš senosios (prieš-React) versijos —
// C:\Mano\Darbas\Fitit\app\src\components\fiFurniture\FiFurnitureService.ts
// (panel/handles/legs masyvai) ir C:\Mano\Darbas\Fitit\app\src\components\
// fiMaterialDialog\FiMaterialDialog.ts (getMDFColor/getMDFColorTone) bei
// atitinkamų *Dialog.html šablonų (kurie laukai/eilutės tiksliai rodomos
// kiekvienam prekės tipui, žr. /admin/bugs "ziurek kaip buvo padaryta").
export const PANEL_LOOKUPS = {
  supplier: [
    { id: 1, name: 'Cleaf' },
    { id: 2, name: 'Gruppo mauro saviola' },
    { id: 3, name: 'Kronospan' },
    { id: 4, name: 'Thermopal' },
    { id: 5, name: 'Egger' },
    { id: 6, name: 'Velvet' },
  ],
  color: [
    { id: 1, name: 'Pilka' }, { id: 2, name: 'Ruda' }, { id: 3, name: 'Balta' },
    { id: 4, name: 'Rusva' }, { id: 5, name: 'Juoda' }, { id: 6, name: 'Geltona' },
    { id: 7, name: 'Raudona' }, { id: 8, name: 'Oranžinė' }, { id: 9, name: 'Žalia' },
    { id: 10, name: 'Violetinė' }, { id: 11, name: 'Mėlyna' }, { id: 12, name: 'Rožinė' },
  ],
  color_tone: [
    { id: 1, name: 'Šviesus' }, { id: 2, name: 'Vidutinis' }, { id: 3, name: 'Tamsus' }, { id: 4, name: 'Ryškus' },
  ],
  gloss: [
    { id: 1, name: 'Turi blizgumo' }, { id: 2, name: 'Neblizgu' }, { id: 3, name: 'Labai blizgu' }, { id: 4, name: 'n/a' },
  ],
  roughness: [
    { id: 1, name: 'Mažas' }, { id: 2, name: 'Didelis' }, { id: 3, name: 'Smulkus apelsinas' },
    { id: 4, name: 'Negrublėta' }, { id: 5, name: 'Kiaušinio lukštas' }, { id: 6, name: 'n/a' },
  ],
  pattern: [
    { id: 1, name: 'Betonas' }, { id: 2, name: 'Medis' }, { id: 3, name: 'Metalas' }, { id: 4, name: 'Tekstilinė' },
    { id: 5, name: 'Oda' }, { id: 6, name: 'Be rašto' }, { id: 7, name: 'Medžio imitacija' }, { id: 8, name: 'Banguota' },
    { id: 9, name: 'Akmuo' }, { id: 10, name: 'Juostuotas' }, { id: 11, name: 'Perlas' },
  ],
};

export const HANDLE_LOOKUPS = {
  manufacturer: [
    { id: 1, name: 'Furnipart' }, { id: 2, name: 'Schueco' }, { id: 3, name: 'Citterio Giulio' },
    { id: 4, name: 'Metakor' }, { id: 5, name: 'Rujz' }, { id: 6, name: 'Giusti' },
  ],
  color: [
    { id: 1, name: 'Juoda' }, { id: 2, name: 'Žalvaris' }, { id: 3, name: 'Balta' }, { id: 4, name: 'Bronzos spalva' },
    { id: 5, name: 'Nerūdijantis plienas' }, { id: 6, name: 'Aukso spalva' }, { id: 7, name: 'Antracito spalvos' },
    { id: 8, name: 'Chromas' }, { id: 9, name: 'Nikelis' }, { id: 10, name: 'Ruda' }, { id: 11, name: 'Pilka' },
    { id: 12, name: 'Aliuminis' }, { id: 13, name: 'Sidabro spalva' }, { id: 14, name: 'Varis' }, { id: 15, name: 'Plienas' },
    { id: 16, name: 'Platina' }, { id: 17, name: 'Alavas' }, { id: 18, name: 'Medis' }, { id: 19, name: 'Ąžuolas' },
    { id: 20, name: 'Riešutas' }, { id: 21, name: 'Bukas' }, { id: 22, name: 'Mėlyna' }, { id: 23, name: 'Žalia' },
    { id: 24, name: 'Geltona' }, { id: 25, name: 'Raudona' }, { id: 26, name: 'Auksas rausvas' }, { id: 27, name: 'Kreminė' },
    { id: 28, name: 'Rožinė' }, { id: 29, name: 'Šviesiai mėlyna' },
  ],
  material: [
    { id: 1, name: 'Metalinė - Ant briaunos' }, { id: 2, name: 'Metalinė - Moderni' }, { id: 3, name: 'Metalinė - Klasika' },
    { id: 4, name: 'Metalinė - Su porcelianu' }, { id: 5, name: 'Medinės' }, { id: 6, name: 'Vaikų baldams' },
    { id: 7, name: 'Metalinės - Su Swarovski' },
  ],
  texture: [
    { id: 1, name: 'Tipinė spalva' }, { id: 2, name: 'Tipinis metalas' }, { id: 3, name: 'Antikinė' }, { id: 4, name: 'Šlifuota' },
    { id: 5, name: 'Žalvario kojelės' }, { id: 6, name: 'Matinė' }, { id: 7, name: 'Juodos kojelės' }, { id: 8, name: 'Blizgi' },
    { id: 9, name: 'Titaninis' }, { id: 10, name: 'Rusva' }, { id: 11, name: 'Chromas' }, { id: 12, name: 'Sendinta' },
    { id: 13, name: 'Blizgi, sendinta' }, { id: 14, name: 'Nikelis' }, { id: 15, name: 'Plastmasė' }, { id: 16, name: 'Matinis chromas' },
    { id: 17, name: 'Nerūdijantis plienas' }, { id: 18, name: 'Vengė' }, { id: 19, name: 'Ąžuolas' }, { id: 20, name: 'Bukas' },
    { id: 21, name: 'Riešutas' }, { id: 22, name: 'Tamsi' }, { id: 23, name: 'Konjako spalva' }, { id: 24, name: 'Rusvai pilka' },
    { id: 25, name: 'Juodas chromas' }, { id: 26, name: 'Juodas nikelis' },
  ],
};

export const LEG_LOOKUPS = {
  manufacturer: [
    { id: 1, name: 'RUJZ' }, { id: 2, name: 'Schuco' },
  ],
  color: [
    { id: 1, name: 'Chromas blizgus' }, { id: 2, name: 'Aliuminis' }, { id: 3, name: 'Nerūdijantis plienas' },
    { id: 4, name: 'Juoda' }, { id: 5, name: 'Balta' }, { id: 6, name: 'Chromas matinis' }, { id: 7, name: 'Pilka' },
    { id: 8, name: 'Nikelis matinis' }, { id: 9, name: 'Tamsi bronza' },
  ],
  material: [
    { id: 1, name: 'Metalinės' }, { id: 2, name: 'Plastikinės' },
  ],
  adjustable_height: [
    { id: 1, name: 'Reguliuojamas' }, { id: 2, name: 'Nereguliuojamas' },
  ],
};

export const MIRROR_COLOR_LOOKUP = { 1: 'Sidabrinė', 2: 'Bronzinė' };

export const MDF_COLOR_LOOKUP = {
  1: 'Balta', 2: 'Pilkšva', 3: 'Rusva', 4: 'Rausva', 5: 'Pilka', 6: 'Gelsva',
  7: 'Rausva', 8: 'Žalsva', 9: 'Ruda', 10: 'Juoda', 11: 'Pasirinktinai',
};

export const MDF_COLOR_TONE_LOOKUP = { 1: 'Šviesus', 2: 'Vidutinis', 3: 'Tamsus', 4: 'Pasirinktinai' };

// Atitinka senosios versijos vm.fs.getMaterialName(category, id) — ieško {id,name}
// masyve pagal id (laisva lygybė, nes DB reikšmės saugomos kaip String, o čia id yra
// Number).
export const getLookupName = (list, rawId) => {
  if (rawId === undefined || rawId === null || rawId === '') return null;
  const found = (list || []).find((el) => String(el.id) === String(rawId));
  return found ? found.name : null;
};
